import { Button, Logo } from "@qn/ui";
import { useQueryClient } from "@tanstack/react-query";
import { useT } from "../lib/i18n";
import { PasskeysSection } from "../pages/settings/Passkeys";
import { TwoFactorSection } from "../pages/settings/TwoFactor";
import { QuickToggles } from "./QuickToggles";

/** Shown instead of the app when the owner requires a second factor and this account has none yet. */
export function Require2fa() {
  const t = useT();
  const qc = useQueryClient();
  return (
    <div className="mx-auto min-h-dvh max-w-xl p-4 pt-10">
      <div className="fixed end-3 top-3 z-10">
        <QuickToggles />
      </div>
      <div className="mb-6 flex flex-col items-center gap-2 text-center">
        <Logo size={44} />
        <h1 className="font-display text-xl font-semibold">{t("require2fa.title")}</h1>
        <p className="text-sm text-[var(--fg-muted)]">{t("require2fa.body")}</p>
      </div>
      <PasskeysSection />
      <TwoFactorSection />
      <div className="mt-4 flex justify-center">
        <Button variant="ghost" onClick={() => void qc.invalidateQueries({ queryKey: ["me"] })}>
          {t("require2fa.done")}
        </Button>
      </div>
    </div>
  );
}
